import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-numero-infracao-taxi-form',
  templateUrl: './text-numero-infracao-taxi.component.html',
  styleUrls: ['./text-numero-infracao-taxi.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNumeroInfracaoTaxiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

}
